<ifc-file-upload-status *ngIf="tempIfcFiles || tempIfcFileErrors"
  [tempIfcFiles]="tempIfcFiles"
  [tempIfcFileErrors]="tempIfcFileErrors"
  (clearErrorEvent)="clearError($event)">
</ifc-file-upload-status>
<div fxLayout="row" fxLayout.lt-md="column">
  <div [fxFlex.gt-sm]="(selectedHome ? 50 : 100)" fxFlex.gt-xs="100" fxFlex="100">
    <mat-card>
      <mat-card-content fxLayout="column" fxFill>
        <mat-form-field class="homeName">
          <mat-label>Home Name</mat-label>
          <input type="text" placeholder="Pick a Home" matInput [formControl]="homeControl" [matAutocomplete]="auto">
        </mat-form-field>
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
          <mat-option *ngFor="let home of filteredHomes | async" [value]="home" [innerHtml]="home | highlight: homeControl.value"></mat-option>
        </mat-autocomplete>
        <mat-label>Add one or more IFC Files</mat-label>
        <div *ngFor="let ifcFile of ifcFiles; index as i" class="ifcFiles" fxLayoutGap="20px">
          <mat-card class="contrast mat-card-inline-sm">
            <mat-card-content>
              <div fxLayout="row" fxLayout.lt-sm="column" fxFlexAlign="center center" fxLayoutGap="10px">
                <mat-form-field class="ifcFile" fxFlex="25">
                  <mat-label>IFC Type</mat-label>
                  <mat-select [(ngModel)]="ifcFile.ifcType" [disabled]="uploadInProgress || tempIfcFiles.length > 0">
                    <mat-option *ngFor="let ifcType of IfcTypeEnum | enumKeyValue" [value]="ifcType.value">
                      {{ifcType.key}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <!-- Hidden button just used for the open file dialog -->
                <input class="file-input" attr.id="IFCFile_{{i}}" type="file" accept=".ifc" accept=".ifc" 
                  (change)="onFileChosen($event, ifcFile)" [disabled]="uploadInProgress || tempIfcFiles.length > 0" />
                <mat-form-field fxFlex="75">
                  <mat-label>Choose a file</mat-label>
                  <input matInput type="text" [value]="ifcFile?.fileName.split('\\').pop().split('/').pop()" (click)="onUploadClick(i);" [readonly]="true">
                  <button matSuffix mat-icon-button aria-label="Upload" (click)="onUploadClick(i);">
                    <mat-icon>attach_file</mat-icon>
                  </button>
                  <button matSuffix mat-icon-button aria-label="remove" (click)="onRemoveIFCFile(ifcFiles, i);" *ngIf="ifcFiles.length > 1">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
        <div fxLayout="row" fxLayout.lt-sm="column" [ngClass.lt-sm]="{'m-b-10': true}">
          <button mat-flat-button color="accent" aria-label="Add" (click)="onAddIFCFile(ifcFiles);" [disabled]="uploadInProgress || tempIfcFiles.length > 0">
            <mat-icon>add</mat-icon>Add another file
          </button>
        </div>
        <div fxLayout="row" fxLayoutAlign="end" fxLayoutAlign.lt-sm="center center" fxLayoutGap="15px">
          <button mat-flat-button color="primary" (click)="save()" [disabled]="uploadInProgress || !homeControl.value || tempIfcFileErrors.length > 0 || tempIfcFiles.length > 0" [class.button-spinner]="uploadInProgress || tempIfcFiles.length > 0">
            <mat-icon>done</mat-icon> Save
          </button>
          <button mat-stroked-button color="basic" aria-label="Cancel" (click)="navigateHome()" [disabled]="uploadInProgress || tempIfcFiles.length > 0">
            <mat-icon>clear</mat-icon> Cancel
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div *ngIf="selectedHome" class="ifc-files-feed" fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
    <ifc-file-list 
      [loading]="ifcFilesLoading"
      [homeIfcFiles]="homeIfcFiles"
      [homeIfcFileErrors]="homeIfcFileErrors">
    </ifc-file-list>
  </div>
</div>

